import FontSelector from './FontSelector';
import DoGuide from '../Tabs/DoGuide';

function App(props) {

  var getOrig = props.getOrig;
  var submitGeneric = props.submitGeneric;
  var mostRecentFont = props.mostRecentFont;
  var setMostRecentFont = props.setMostRecentFont;
  var addToExtraScreen = props.addToExtraScreen;

      var addChanges = [];
      var origFont = getOrig('fontFamily');
      function clickFontFamily1(g){
        submitGeneric({t:'font', v:g}, 'fontFamily', addChanges);
      }
      return (<td><center>
        <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'fontFamily'}} />
        </center><FontSelector clickFontFamily={clickFontFamily1} currentFont={origFont} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont} /></td>);
//
}

//
export default App;
